/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { t } from 'localization/utils/t';
import styled from 'styled-components';
import Text from '../Text';
import { formatDate } from './utils/dates';
import { localizeUrl } from './getLocale';
import { createSanitizedHtmlObject } from './utils/createSanitizedHtml';

const TP = 'shared.components.Grid.GridHeader';

const gridTitle = ({ releaseDate, title, searchQuery, shopAllText }: any) => {
  if (releaseDate) {
    return `Release Date ${formatDate.monthYear(Number.parseInt(releaseDate, 10))}`;
  }

  return title || searchQuery || shopAllText;
};

const ProductGridHeader = ({
  collectionDetails,
  total,
  offset = {
    left: 0,
    right: 0,
  },
  isMobile,
  resetQuery,
}: {
  total: number;
  isMobile?: boolean;
  collectionDetails?: {
    title?: string;
    metadata_description?: string;
    description?: string;
    header_assets?: any;
    shopAll?: string;
    detailsText?: string;
    getTotal: (total: number) => string;
  };
  offset?: {
    right?: number;
    left?: number;
  };
  resetQuery?: () => void;
}) => {
  const router = useRouter();
  const { query } = router.query || {};
  const [isModalVisible, setIsModalVisible] = useState(false);

  const hasNoQuery = useCallback(
    () =>
      Object.keys(router.query || {}).filter(
        (q) => q !== 'query' && q !== 'pageNumber' && q !== 'slug',
      ).length === 0,
    [router.query],
  );

  const releaseDate = router.query?.releaseDateStart as string;

  return (
    <div
      className="tw-flex tw-justify-between tw-items-center tw-py-4"
      style={{
        padding:
          isMobile || !collectionDetails
            ? `${isMobile ? '16px' : '32px'} ${isMobile ? '16px' : `${offset.right / 2}px`} ${isMobile ? '16px' : '32px'} ${offset.left}px`
            : `160px ${offset.right}px 320px ${offset.left}px`,
        maxHeight: 526,
      }}
    >
      <div className="tw-flex tw-gap-6 tw-align-baseline">
        <Text as="h1" className="tw-font-bold tw-uppercase" data-qa="grid_header_title">
          {gridTitle({
            releaseDate,
            title: collectionDetails?.title,
            searchQuery: query,
            shopAllText: collectionDetails?.shopAll || (query as string) || 'Shop All',
          })}
        </Text>
        {collectionDetails?.description &&
          (isMobile ? (
            <div>
              <ProductGridHeader.details
                data-qa="details_button"
                onClick={() => setIsModalVisible((p: boolean) => !p)}
              >
                {collectionDetails?.detailsText || 'Details'}
              </ProductGridHeader.details>
              {isModalVisible && (
                <ProductGridHeader.Modal data-qa="grid_header_description_modal">
                  {collectionDetails?.description && (
                    <div
                      dangerouslySetInnerHTML={createSanitizedHtmlObject(
                        localizeUrl(collectionDetails?.description, router.locale),
                      )}
                    />
                  )}
                </ProductGridHeader.Modal>
              )}
            </div>
          ) : (
            <ProductGridHeader.description
              id="grid-header-description"
              data-qa="grid_header_description"
            >
              <div
                dangerouslySetInnerHTML={createSanitizedHtmlObject(
                  localizeUrl(collectionDetails?.description, router.locale),
                )}
              />
            </ProductGridHeader.description>
          ))}
      </div>
      <div
        className="tw-flex tw-items-center tw-gap-3"
        data-qa="results-count"
        style={{ gap: hasNoQuery() ? '0px' : '12px' }}
      >
        <Text style={{ fontSize: '11.5px' }}>
          {collectionDetails?.getTotal?.(total) || typeof total === 'number'
            ? total >= 10000
              ? t(`${TP}.maxCount`, '10,000+ Items')
              : t(`${TP}.itemsCount`, '{numItems, plural, =1 {1 Item} other {# Items}}', {
                  numItems: total,
                })
            : t(`${TP}.itemsCount`, '{numItems, plural, =1 {1 Item} other {# Items}}', {
                numItems: 0,
              })}
        </Text>

        {isMobile && (
          <div
            className="tw-cursor-pointer hover:tw-underline"
            onClick={() => {
              if (!hasNoQuery()) {
                resetQuery?.();
              }
            }}
            data-qa={hasNoQuery() ? '' : 'clear-filters'}
          >
            {hasNoQuery() ? '' : 'Reset'}
          </div>
        )}
      </div>
    </div>
  );
};

ProductGridHeader.description = styled('div')`
  a {
    text-decoration: underline;
  }
`;

ProductGridHeader.details = styled('button')`
  cursor: pointer;
  border: 1px solid transparent;
  &:hover {
    border-bottom: 1px solid;
  }
`;
ProductGridHeader.Modal = styled('div')`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.7);
  color: #000000;
  position: absolute;
  font-weight: 400;
  font-size: 11.5px;
  line-height: 14px;
  padding: 16px;
  left: 16px;
  top: 40px;
  right: 16px;
  min-width: calc(100vw - 40px);
  z-index: 700;
  position: absolute;
  a {
    text-decoration: underline;
  }

  #has-link {
    &:hover {
      border: none;
    }
  }
`;

export default ProductGridHeader;
